import React, { useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import { PageHeader } from "@/pages/Classes";
import { sanitizeHtml } from "@/lib/sanitize";

// Strip inline `color:`, `background:` and `font-family:` from pasted HTML so admin's chosen colour
// (or default zinc-300) wins. Word / Google Docs paste often forces black-on-black which makes the
// copy invisible on our dark theme.
function stripInlineColour(html) {
  if (!html || typeof html !== "string") return html;
  return html
    .replace(/color\s*:\s*[^;"']+;?/gi, "")
    .replace(/font-family\s*:\s*[^;"']+;?/gi, "")
    .replace(/background(?:-color)?\s*:\s*[^;"']+;?/gi, "");
}

export default function About() {
  const { settings } = useOutletContext();
  const color = settings?.about_story_color || "#d4d4d8"; // default = zinc-300
  const story = useMemo(() => stripInlineColour(settings?.about_story || "<p>2RightFeet is a family-run Hip Hop dance school.</p>"), [settings?.about_story]);
  return (
    <>
      <PageHeader eyebrow="Our story" title="About 2RightFeet" />
      <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-12">
        <div
          className="text-lg leading-relaxed [&_p]:mb-4 [&_a]:underline [&_*]:!text-inherit"
          data-testid="about-story"
          style={{ color }}
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(story) }}
        />
      </div>
    </>
  );
}
